module.exports = __webpack_public_path__ + "img/2.ffa913d7.jpg";